import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const paths = {
  recommendedListing: generateApiPath({ prefix: AuthLevel.PUBLIC, name: 'recommended-listing' }),
}

export { paths }
